'use strict';

// // AngularJS
//const angular = require('angular');
import "angular";
//import "angular-sanitize";
//
////import "angular-route";
//import "angular-messages";
//
////import "angular-cookies";
//import "angular-animate";
//import "angular-aria";


var EwSiteApp = angular.module('EwSiteApp', []);

EwSiteApp.config(['$provide', function ($provide) {
		$provide.decorator('$browser', ['$delegate', function ($delegate) {
				$delegate.onUrlChange = function () {};
				$delegate.url = function () {
					return "";
				};
				return $delegate;
			}]);
	}]);

EwSiteApp.filter('u2date', ['$filter', function ($filter) {
		return function (udate) {
			var format = 'yyyy-MM-dd';
			if (arguments[1]) {
				format = arguments[1];
			}
			return $filter('date')(udate * 1000, format);
		};
	}]);

EwSiteApp.service("ajaxSearch", ['$http', '$q', function ($http, $q) {
		return({
			search: search
		});

		function search(url) {
			var cfg = {
				method: 'GET',
				url: url
			};
			if (arguments[1]) {
				cfg.params = arguments[1];
			}
			var request = $http(cfg);
			return(request.then(succesHandler, errorHandler));
		}
		;

		function succesHandler(response) {
			return response.data;
		}

		function errorHandler(response) {
			if (!angular.isObject(response.data) || !response.data.message) {
				return($q.reject("An unknown error occurred."));
			}
			return($q.reject(response.data.message));
		}
		;
	}]);

export {EwSiteApp};